import { AZURE_URL } from "../constants/env-constants";

export const getWixBookings = async (query: any) => {
  try {
    const response = await AZURE_URL.post(
      "/booking/loadWixBookings/query",
      query
    );
    if (response.status === 200) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return [null, "Server error:" + error.response];
  }
};
